module.exports = __webpack_public_path__ + "img/vegan.20c2813e.jpg";